import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ComponentVisibility, TextInput } from '../../types'
import { WindowRef } from '@spartacus/core'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-campus-modal',
  templateUrl: './campus-modal.component.html',
  styleUrls: ['./campus-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampusModalComponent implements OnInit {

  @Input() id: string | undefined
  @Input() headline: TextInput | undefined
  @Input() description: TextInput | undefined
  @Input() buttonText: string | undefined
  @Input() flexType: string | any


  constructor (private modal: NgbActiveModal,
               private winRef: WindowRef) {
  }

  ngOnInit (): void {
    if (this.winRef.nativeWindow?.Cypress) {
      this.winRef.nativeWindow[this.flexType] = this as any
    }
  }

  close (): void {
    this.modal.close()
  }

  protected readonly cmsLinkType = CmsLinkType
}

export interface CampusModalData {
  id: string;
  visibility: ComponentVisibility;
  headline: TextInput;
  description: TextInput;
  buttonText: string;
  modalSize: string;
  flexType: string;
}
